// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_0eV","cls2":"SearchBox-cls2_F_0 SearchBox-cls1_0eV"};